
import InvoiceCreate from '@/views/crm/invoice/Create';
import CustomerCreate from '@/views/crm/customer/Create';
import ContactsCreate from '@/views/crm/contacts/Create';
import LeadsCreate from '@/views/crm/leads/Create';
import BusinessCreate from '@/views/crm/business/Create';
import ContractCreate from '@/views/crm/contract/Create';
import ReceivablesCreate from '@/views/crm/receivables/Create';
import ReceivablesPlanCreate from '@/views/crm/receivables/PlanCreate';
import VisitCreate from '@/views/crm/visit/Create';
import ProductCreate from '@/views/crm/product/Create';

export default {
  name: 'CRMAllCreate',
  components: {
    InvoiceCreate: InvoiceCreate,
    CustomerCreate: CustomerCreate,
    ContactsCreate: ContactsCreate,
    BusinessCreate: BusinessCreate,
    ContractCreate: ContractCreate,
    ReceivablesCreate: ReceivablesCreate,
    ReceivablesPlanCreate: ReceivablesPlanCreate,
    VisitCreate: VisitCreate,
    LeadsCreate: LeadsCreate,
    ProductCreate: ProductCreate
  },
  inheritAttrs: false,
  props: {
    crmType: String
  },
  data: function data() {
    return {};
  },

  computed: {
    componentName: function componentName() {
      return {
        invoice: 'InvoiceCreate',
        customer: 'CustomerCreate',
        contacts: 'ContactsCreate',
        leads: 'LeadsCreate',
        business: 'BusinessCreate',
        contract: 'ContractCreate',
        receivables: 'ReceivablesCreate',
        visit: 'VisitCreate',
        product: 'ProductCreate',
        receivables_plan: 'ReceivablesPlanCreate'
      }[this.crmType];
    }
  },
  watch: {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    hiddenView: function hiddenView() {
      this.$emit('close');
    },
    createSaveSuccess: function createSaveSuccess(data) {
      this.$emit('save-success', data);
    }
  }
};